/**
 * @fileoverview added by tsickle
 * Generated from: pipes/number-pipes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { range } from 'lodash-es';
import { Pipe } from '@angular/core';
/**
 * Pipe to return an Array representing a range between 0 and the number given.
 */
import * as ɵngcc0 from '@angular/core';
var Range = /** @class */ (function () {
    function Range() {
    }
    /**
     * @param {?} count
     * @return {?}
     */
    Range.prototype.transform = /**
     * @param {?} count
     * @return {?}
     */
    function (count) {
        return range(count);
    };
Range.ɵfac = function Range_Factory(t) { return new (t || Range)(); };
Range.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "range", type: Range, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Range, [{
        type: Pipe,
        args: [{ name: 'range' }]
    }], function () { return []; }, null); })();
    return Range;
}());
export { Range };

